import OneTimeChargeModal from 'app/views/modals/one_time_charge_modal';
import PaymentMethodRemoveModal from 'app/views/modals/payment_method_remove_modal';
import RechargeSettingsView from 'app/views/recharge_settings_view';

import Base from 'app/views/base';
import tmpl from 'templates/credit_card_details';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click .remove_card': 'showRemoveModal',
    'click .one-time-charge': 'showOneTimeChargeModal',
  },

  initialize({ priority, paymentMethods, user }) {
    this.priority = priority;
    this.paymentMethods = paymentMethods;
    this.user = user;

    this.oneTimeChargeModal = new OneTimeChargeModal({
      user: this.user,
      model: this.model,
      collection: this.collection,
    });

    this.addSubview('rechargeSettings', '.recharge_settings', new RechargeSettingsView({
      model: this.user, priority: this.priority,
    }));
  },

  context() {
    return {
      name: this.model.get('name'),
      last4: this.model.get('last4'),
      exp_month: this.model.get('exp_month'),
      exp_year: this.model.get('exp_year'),
      brand: this.model.get('brand'),
      brandImgClass: this.brandImgMap(this.model.get('brand')),
    };
  },

  brandImgMap(brand) {
    const map = {
      'American Express': 'american-express',
      MasterCard: 'mastercard',
      Visa: 'visa',
    };
    return map[brand] || 'unknown-cc';
  },

  showOneTimeChargeModal(event) {
    event.preventDefault();
    this.oneTimeChargeModal.show();
  },

  showRemoveModal(event) {
    event.preventDefault();
    if (this.removeModal) { this.removeModal.close(); }

    this.removeModal = new PaymentMethodRemoveModal({
      model: this.model,
      collection: this.paymentMethods,
      priority: this.priority,
    });
    this.removeModal.show();
  },
});



// WEBPACK FOOTER //
// ./app/views/credit_card_details_view.js